import { computed } from 'vue';
import { useStore } from 'vuex';
import yup from '@component_path/inquiry_form_common_module/customValidation';

export const useEmailField = (required, messages = {}) => {
  const fieldName = computed(() => 'email');
  const validator = yup
    .string()
    .max(80, messages['max'] || 'メールアドレスは80文字以内にしてください')
    .emailFormat(messages['emailFormat'] || 'メールアドレスが正しくありません')
    .requirement(
      required,
      messages['requirement'] || 'メールアドレスは必須項目です'
    );

  return { validator, fieldName };
};

export const useEmailStore = () => {
  const store = useStore();

  const email = computed(() => store.state.formData.email);
  const dispatcher = computed(() => 'formData/setEmail');

  return { email, dispatcher };
};
